import { useCallback, useState } from "react";

import client from "../client";
import handleApiError from "../../hooks/handleApiError";
import { handleToast } from "../../utils/functions";

export default function useUpdateBillingSettings() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const request = useCallback(async (id, payload) => {
    try {
      setLoading(true);
      const response = await client.put(
        `/school/billing/update/${id}`,
        payload
      );

      setData(response.data?.data);

      setLoading(false);
      handleToast(response.data?.message);
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { request, loading, data };
}
